// Import GSAP
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

class PageAnimation {
  panel: HTMLElement | null

  constructor(panel: HTMLElement | null) {
    // Find all necessary elements
    this.panel = panel

    // Init functionalities if all elements has been found
    if (this.panel) {
      this.init(this.panel)
    } else {
      console.error('missing elements to properly init animations')
    }
  }

  /**
   * Init all default functionalities
   */
  init(panel: HTMLElement) {
    const panelName = panel.getAttribute('data-animation-section')

    switch (panelName) {
      case 'pin':
        this.pin(panel)
        break

      default:
        break
    }
  }

  pin(panel: HTMLElement) {
    function setVH() {
      document.documentElement.style.setProperty(
        "--vh",
        window.innerHeight * 0.01 + "px"
      );
    }
    setVH();
    window.addEventListener("resize", setVH);



    const track = panel.querySelector(".materials__content");
    const items = gsap.utils.toArray(".item", track);
    const header = document.querySelector('[data-item="header"]')

    function getTrackWidth() {
      let width = 0;
      items.forEach(item => width += item.offsetWidth);
      return width;
    }

    let trackWidth = getTrackWidth();
    let lastGap = items[0].offsetWidth + (items[0].offsetWidth / 3);


    if (window.innerWidth < 992) {
      lastGap = items[0].offsetWidth - (items[0].offsetWidth / 3);
    }
    if (window.innerWidth < 768) {
      lastGap = 60;
    }

    let sectionGap = 50;
    if (window.innerWidth > 768) {
      sectionGap = 20;
    }
    else {
      sectionGap = 70;
    }
    if (window.innerWidth < 768) {
      sectionGap = 0;
    }

    gsap.to(track, {
      x: () => -(trackWidth - panel.offsetWidth + lastGap),
      ease: "none",
      scrollTrigger: {
        trigger: panel,
        start: `bottom-=${sectionGap} bottom`,
        end: () => "+=" + (trackWidth - panel.offsetWidth + lastGap),
        scrub: true,
        pin: panel,
        anticipatePin: 1,

        onEnter: () => header?.classList.add("hidden"),
        onLeave: () => header?.classList.remove("hidden"),
        onEnterBack: () => header?.classList.add("hidden"),
        onLeaveBack: () => header?.classList.remove("hidden")
      }
    });
    ScrollTrigger.addEventListener("refreshInit", () => {
      trackWidth = getTrackWidth();
    });
  }

}

window.addEventListener('load', () => {
  // Find all section to full page animation
  const panels = document.querySelectorAll<HTMLElement>(
    '[data-animation-section]',
  )

  if (panels.length > 0) {
    panels.forEach((panel) => {
      setTimeout(() => {
        new PageAnimation(panel)
      }, 500)
    })
  }
})
